module.exports = __webpack_public_path__ + "static/media/create-page-dropdown.37b67da3.png";